import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './globals.css'

import { ThemeProvider } from '@/providers'
import App from './App'
import * as Sentry from "@sentry/react"

Sentry.init({
  dsn: "https://bd57e771ea63232e43d97bf0a4c8abb5@o4509765108629504.ingest.de.sentry.io/4509765110661200",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  beforeSend(event) {
    // Filter out expected errors that are part of normal application flow
    if (event.exception?.values?.[0]?.value?.includes('Cannot create service wrapper for not-set provider') ||
        event.exception?.values?.[0]?.value?.includes('Service wrapper cannot be created - provider not initialized')) {
      return null // Don't send this error to Sentry
    }
    return event
  }
})


// Get the root element
const container = document.getElementById('root')
// Create a root
const root = createRoot(container!)

// Render your app
root.render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
)
